import React, { useContext } from "react"
import { Helmet } from "react-helmet"

import { identity } from "ramda"

import { useLocalization } from "@izettle/lingo-client"

import { ScreenReaderOnly } from "../screen-reader-only"

import { PageTitleContext } from "./context"

export const PageTitle: React.FC = () => {
  const { text } = useLocalization()
  const pageTitleContext = useContext(PageTitleContext)
  const titleParts = [pageTitleContext?.title, text("APP_NAME"), text("COMPANY_NAME")]
  const pageTitle = titleParts.filter(identity).join(" – ")

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <ScreenReaderOnly as="h1" aria-live="polite">
        {pageTitleContext?.title}
      </ScreenReaderOnly>
    </>
  )
}
